export function currencyTypeOptions(supplierCurrency) {
  return [
    { id: 'useOriginalCurrency', value: 'original_currency', label: 'Export in Original Order Currency' },
    {
      id: 'useDefaultCurrency',
      value: 'default_currency',
      label: `Export in converted currency - ${supplierCurrency}`,
    },
  ];
}
